<template>
  <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      d="M20 3H4C2.897 3 2 3.897 2 5V7C2 7.736 2.405 8.375 3 8.722V19C3 20.103 3.897 21 5 21H19C20.103 21 21 20.103 21 19V8.722C21.595 8.375 22 7.736 22 7V5C22 3.897 21.103 3 20 3ZM4 5H20L20.002 7H20H4V5ZM5 19V9H19L19.002 19H5Z"
      fill="currentColor"
    />
    <path d="M8 11H16V13H8V11Z" fill="currentColor" />
  </svg>
</template>

<script>
export default {
  name: 'MyCollectionIcon',
};
</script>
